import { useCallback, useRef } from 'react';
import { MESSAGE_EVENT, MESSAGE_TYPES } from '../constants/simulationConstants';
import { postMessage } from '../helpers/utils';
import { useSimulationContext } from '../providers/SimulationProvider';
import userEmotionIntervalConfig from '../config/userEmotionIntervalConfig';
import useEmotionIntervalScheduler from './useEmotionIntervalScheduler';

function useCoreRequestUserEmotionInterval({
  isClientInitialized,
  isAiTalking,
  isAiResponseInFlight
}) {
  const { isEmotionRecognitionEnabled, isLiveChatActive } =
    useSimulationContext();

  const isAiTalkingRef = useRef(isAiTalking);
  const isAiResponseInFlightRef = useRef(isAiResponseInFlight);

  isAiTalkingRef.current = isAiTalking;
  isAiResponseInFlightRef.current = isAiResponseInFlight;

  const intervalDurationMs =
    userEmotionIntervalConfig.USER_EMOTION_INTERVAL_DURATION_MS;

  const requestUserEmotion = useCallback(() => {
    const isConversationIdle =
      !isAiTalkingRef.current && !isAiResponseInFlightRef.current;

    if (
      !isClientInitialized ||
      !isEmotionRecognitionEnabled ||
      isLiveChatActive ||
      !isConversationIdle
    ) {
      return;
    }

    try {
      postMessage({
        type: MESSAGE_TYPES.REQUEST_USER_EMOTION,
        payload: { event: MESSAGE_EVENT.USER_EMOTION_INTERVAL }
      });
    } catch (error) {
      console.error('[Core Emotion Interval Error]:', error);
    }
  }, [isClientInitialized, isEmotionRecognitionEnabled, isLiveChatActive]);

  const isEnabled =
    isClientInitialized && isEmotionRecognitionEnabled && !isLiveChatActive;
  const isBusy = isAiTalking || isAiResponseInFlight;

  const { cleanupEmotionInterval } = useEmotionIntervalScheduler({
    isEnabled,
    isBusy,
    intervalDurationMs,
    onTick: requestUserEmotion
  });

  return { requestUserEmotion, cleanupEmotionInterval };
}

export default useCoreRequestUserEmotionInterval;
